import { FD_PROXY } from './constants';

export const getFdProxyAndUrl = (fdUrl: string) => {
  return [FD_PROXY, fdUrl];
};
